export const environment = {
  production: true,
  buildId: '3150065260320831',
  configFile: 'config.json',
};
